import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

const fallbackServices = [
    {
        count: 1,
        title: 'Building Construction',
        icon: require('./../../images/icon/crane-1.png'),
        description: 'High standard construction services adhering strictly to safety and green building practices.',
    },
    {
        count: 2,
        title: 'Building Renovation',
        icon: require('./../../images/icon/renovation.png'),
        description: 'Complete remodeling and renovation solutions modernizing spaces for maximum energy efficiency.',
    },
    {
        count: 3,
        title: 'Building Maintenance',
        icon: require('./../../images/icon/toolbox.png'),
        description: 'Preventative and ongoing building maintenance keeping equipment and structures in peak condition.',
    },
    {
        count: 4,
        title: 'Architecture Design',
        icon: require('./../../images/icon/compass.png'),
        description: 'Innovative architectural design blending modern aesthetics with functional and sustainable engineering.',
    },
    {
        count: 5,
        title: 'Construction Consultant',
        icon: require('./../../images/icon/idea.png'),
        description: 'Expert advisory services guiding project planning, budgeting, feasibility, and regulatory approval.',
    },
    {
        count: 6,
        title: 'Material Supply',
        icon: require('./../../images/icon/dump-truck.png'),
        description: 'Reliable sourcing and logistics for high quality construction materials and equipment.',
    },
    {
        count: 7,
        title: 'House Renovation',
        icon: require('./../../images/icon/architecture.png'),
        description: 'Residential remodeling transforming living spaces to meet client lifestyle and sustainability goals.',
    },
    {
        count: 8,
        title: 'Interior Design',
        icon: require('./../../images/icon/planning.png'),
        description: 'Tailored interior concepts maximizing natural lighting, ventilation, and premium spatial flow.',
    }
];

var img1 = require('./../../images/background/ptn-1.png');

class OurServices2 extends React.Component {
    state = {
        services: fallbackServices,
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                const apiServices = res.data.data || [];
                if (apiServices.length > 0) {
                    const mapped = apiServices.map((s, idx) => ({
                        count: idx + 1,
                        title: s.name,
                        icon: fallbackServices[idx % fallbackServices.length].icon,
                        description: s.description || fallbackServices[idx % fallbackServices.length].description
                    }));
                    this.setState({ services: mapped, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                console.error("Error fetching services", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { services } = this.state;
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="section-content">
                        <div className="container">
                            {/* TITLE START */}
                            <div className="section-head m-b50">
                                <div className="mt-separator-outer separator-left">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Services</h2>
                                    </div>
                                </div>
                                <h3>High quality architectural, engineering and construction solutions</h3>
                            </div>
                            {/* TITLE END */}
                            <div className="row services-v2 no-col-gap">
                            {services.map((item, index) => (
                                <div className="col-md-3 col-sm-6 col-xs-6 col-xs-100pc" key={index}>
                                    <div className="mt-icon-box-wraper bdr-l-1 bdr-solid bdr-gray">
                                        <div className="relative  p-a30">
                                            <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                <span className="icon-cell"><img src={item.icon} alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte m-b25">{item.title}</h4>
                                                <p>{item.description}</p>
                                                <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices2;
